// Stroke weight and point radius for one plan shape, from its base size and
// whether it is selected or hovered. Selection wins: a hovered selected
// shape draws as selected, so a hover can never clobber or shrink the pick.
export const SELECT_WEIGHT_BOOST = 2;
export const HOVER_WEIGHT_BOOST = 1;

export interface PlanShapeState {
  selected: boolean;
  hovered: boolean;
}

export function hoverStyleFor(
  base: { weight: number; radius?: number },
  state: PlanShapeState
): { weight: number; radius?: number } {
  const boost = state.selected ? SELECT_WEIGHT_BOOST : state.hovered ? HOVER_WEIGHT_BOOST : 0;
  return {
    weight: base.weight + boost,
    ...(base.radius !== undefined ? { radius: base.radius + boost } : {}),
  };
}

/** Ids to un-hover and to hover when the hovered set moves from `prev` to
 *  `next`. The layer restyles only these, never the whole plan. */
export function diffHoverIds(
  prev: ReadonlySet<string>,
  next: ReadonlySet<string>
): { off: string[]; on: string[] } {
  const off: string[] = [];
  const on: string[] = [];
  for (const id of prev) if (!next.has(id)) off.push(id);
  for (const id of next) if (!prev.has(id)) on.push(id);
  return { off, on };
}
